import { Component, Input, OnInit } from '@angular/core';

import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-recent-activity-list',
  templateUrl: './recent-activity-list.component.html',
  styleUrls: ['./recent-activity-list.component.css']
})
export class RecentActivityListComponent implements OnInit {

  @Input() list: any[];

  constructor(
    public service: ServicecallService
  ) { }

  ngOnInit(): void {
  }

}
